import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CreditApplicationFormModel } from "@tCooneyBrothers/ApiModels";
import { addCreditApplicationFields as addCreditApplicationApi } from "@tCooneyBrothers/Services/CreditApplicationFormService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type CreditApplicationParam = {
    addCreditApplicationParams: CreditApplicationFormModel;
} & HasOnSuccess;

type HandlerType = CustomApiHandler<CreditApplicationParam, CreditApplicationFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addCreditApplicationApi(props.parameter.addCreditApplicationParams);
};

export const DispatchCreditApplicationFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CreditApplicationFields/fields",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};
export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCreditApplicationFields,
    ExecuteOnSuccessCallback,
];

const addCreditApplicationFormFields = createHandlerChainRunner(chain, "addCreditApplicationFields");
export default addCreditApplicationFormFields;
